import React from "react";

import { NotFound } from "../../../modules/notFound/NotFound";

export function NotFoundPage() {
  return <NotFound />;
}
